module.exports = __webpack_public_path__ + "static/media/uoa-3.49b8214b.jpg";